import React from 'react';
import PropTypes from 'prop-types';
import { Manager, Reference } from 'react-popper';

import { MoreButton } from 'components';

import Popover from './Popover';


export default class PopoverWrapper extends React.PureComponent {
	static propTypes = {
		isOpen: PropTypes.bool,
		hideTrigger: PropTypes.bool,
		propagateToggle: PropTypes.bool,
		closeOnOutsideClick: PropTypes.bool,
		popoverOptions: PropTypes.object,
		children: PropTypes.node.isRequired,

		onToggle: PropTypes.func.isRequired,
		renderToggleBtn: PropTypes.func
	}
	static defaultProps = {
		isOpen: false,
		hideTrigger: false,
		propagateToggle: false,
		closeOnOutsideClick: true,
		popoverOptions: null
	}

	/* Lifecycle Methods */

	componentDidMount() {
		document.addEventListener('click', this.handleBackgroundClick, true);
		// Extra listener for mobile
		document.addEventListener('touchstart', this.handleBackgroundClick, true);
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleBackgroundClick, true);
		document.removeEventListener('touchstart', this.handleBackgroundClick, true);
	}

	/* Refs */

	setPopperRef = (ref) => {
		this.popperRef = ref;
	}

	setButtonRef = (ref) => {
		this.buttonRef = ref;
	}

	/* Event Handlers */

	handleBackgroundClick = (event) => {
		const { isOpen, onToggle, closeOnOutsideClick } = this.props;

		if (!isOpen || !closeOnOutsideClick) return;

		const isNotPopperClick = this.popperRef && !this.popperRef.contains(event.target);
		const isNotButtonClick = this.buttonRef && !this.buttonRef.contains(event.target);

		if (isNotPopperClick && isNotButtonClick && typeof onToggle === 'function') {
			onToggle();
		}
	}

	handleToggleClick = (event) => {
		const { onToggle, propagateToggle } = this.props;

		if (!propagateToggle) event.stopPropagation();
		onToggle(event);
	}

	/* Rendering */

	renderToggleBtn = ({ ref, onClick }) => (
		<MoreButton innerRef={ref} onClick={onClick} />
	);

	renderToggle = ({ ref }) => {
		const { hideTrigger, renderToggleBtn } = this.props;

		const wrapperClass = hideTrigger
			? 'opacity-0'
			: 'opacity-100';

		const renderCall = typeof renderToggleBtn === 'function'
			? renderToggleBtn
			: this.renderToggleBtn;


		return (
			<span ref={this.setButtonRef} className={wrapperClass}>
				{ renderCall({ ref, onClick: this.handleToggleClick }) }
			</span>
		);
	}

	render() {
		const { isOpen, children, popoverOptions } = this.props;

		return (
			<Manager>
				<Reference>
					{ this.renderToggle }
				</Reference>
				{
					isOpen &&
					<Popover
						innerRef={this.setPopperRef}
						{...popoverOptions}>
						{ children }
					</Popover>
				}
			</Manager>
		);
	}
}
